import styled from 'styled-components';

import { NewStyleColor } from '../../../utils/styles-constants';

interface EditorToggleProps {
	isVisible: boolean;
}

interface BorderProps {
	borderWidth: number;
	isActive: boolean;
}

const Wrapper = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;

	/* hide all button's children except editor */
	/* DO NOT ADD any prop to this component as it will create a new className and break this rule */
	._idGenButton[data-hidden] > :not(&) {
		display: none;
	}
`;

const EditorToggle = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	pointer-events: auto;

	${({ isVisible }: EditorToggleProps) => isVisible && 'z-index: -1;'}
`;

const Border = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	border: ${({ borderWidth, isActive }: BorderProps) => `${borderWidth}px solid ${isActive ? NewStyleColor.Blue100 : NewStyleColor.Grey400}`};
	border-radius: inherit;
`;

export {
	Wrapper,
	EditorToggle,
	Border,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonEditor/styles.ts